import axiosInstance from '@/apis/axiosInstance';
import { langList } from './index';

const lsLangKey = 'i18nextLng';

/**
 * 获取检测到的用户语言
 *   如果用户有合法的 localStorage 值，则返回对应的语言对象。否则返回默认 en Item
 *   如果没有检测到任何值，则返回默认 en Item
 */
export function getUserLang(sync = false) {
  const lsLangValue = localStorage.getItem(lsLangKey);
  if (lsLangValue) {
    const found = langList.find((lang) => lang.detectedValue === lsLangValue);
    if (found) {
      return found;
    } else {
      if (sync) {
        localStorage.setItem(lsLangKey, langList[0].detectedValue);
      }
      return langList[0];
    }
  } else {
    if (sync) {
      localStorage.setItem(lsLangKey, langList[0].detectedValue);
    }
    return langList[0];
  }
}

/**
 * 处理本地检测语言和 Settings 中的语言冲突
 */
export function handleLangConflict(lang: string, initUserLang: string) {
  localStorage.setItem(lsLangKey, lang);
  console.log(
    '[i18n]: need reload, user.lang=',
    lang,
    ', while initUserLang=',
    initUserLang
  );
  window.location.reload();
}

/**
 * 处理语言设置切换
 */
export async function handleI18nChange(lang: string) {
  localStorage.setItem(lsLangKey, lang);
  await axiosInstance
    .post('/influencer/info', {
      lang
    })
    .finally(() => {
      window.location.reload();
    });
}
